import React from "react";
import NewsletterThirty from "../component/NewsletterThirty";

function NewsletterThirtyContainer() {
  return <NewsletterThirty />;
}

export default NewsletterThirtyContainer;
